import invokeClient from './invokeClient';
export const getCurrentDeviceModel = () => {
    return invokeClient.invoke({
        functionName: 'getCurrentDeviceModel',
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGV2aWNlTW9kZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9saWIvZGV2aWNlTW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxZQUFZLE1BQU0sZ0JBQWdCLENBQUM7QUFFMUMsTUFBTSxDQUFDLE1BQU0scUJBQXFCLEdBQUcsR0FBRyxFQUFFO0lBQ3hDLE9BQU8sWUFBWSxDQUFDLE1BQU0sQ0FBQztRQUN6QixZQUFZLEVBQUUsdUJBQXVCO0tBQ3RDLENBQUMsQ0FBQztBQUNMLENBQUMsQ0FBQyJ9